import { numberWithThousandSeparator } from "./numbers"

export const investmentDescriptionHandler = (information: number[], description: string) => {
    let descriptionToModify = description

    information.forEach((i, index) => {
        const pattern = `{${index}}`
        descriptionToModify = descriptionToModify.replace(pattern, `<strong>${numberWithThousandSeparator(i)}</strong>`)
    })

    return descriptionToModify
}
